import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { fetchUserAuthenticationInfo } from 'modules/accountManagement/actions';
import { loginValidationErrorType } from 'modules/accountManagement/enum';
import LoginComponent from 'modules/accountManagement/components/LoginComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
const requiredFormFieldsWithRegexValidation = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i,
};

const requiredFormFields = ['email', 'password'];
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    email: '',
    password: '',
  });

  const [formFieldsValidation, setFormFieldsValidation] = useState({
    email: loginValidationErrorType.valid,
    password: loginValidationErrorType.valid,
  });
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const submitUserLoginData = (username, password) => {
    const body = {
      data: {
        username,
        password,
      },
    };

    dispatch(fetchUserAuthenticationInfo(body));
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleSubmitBtnClick = () => {
    let isFormValid = true;
    requiredFormFields.forEach(fieldName => {
      let isFieldValid = loginValidationErrorType.valid;

      if (
        !formFieldsValues[fieldName].toString() ||
        (requiredFormFieldsWithRegexValidation[fieldName] &&
          requiredFormFieldsWithRegexValidation[fieldName].test(formFieldsValues[fieldName]) ===
            false)
      ) {
        isFieldValid =
          (!formFieldsValues[fieldName] && loginValidationErrorType.empty) ||
          loginValidationErrorType.wrong;
        isFormValid = false;
      }

      setFormFieldsValidation(prevState => ({
        ...prevState,
        [fieldName]: isFieldValid,
      }));
    });

    if (isFormValid === false) return;

    submitUserLoginData(formFieldsValues.email, formFieldsValues.password);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      handleInputFieldChange={handleInputFieldChange}
      handleSubmitBtnClick={handleSubmitBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

export default LoginContainer;
